










































































































































import { Component, Prop } from 'vue-property-decorator';
import i18n from '@/services/i18n';
import { ComponentBase } from '../components';
import type { Fzp } from './types';


const translates = {
    modal: {
        actions: {
            get add(): string {
                return i18n.choose(
                    'Добавить',
                    'Қосу',
                    'Add',
                );
            },
            get cancel(): string {
                return i18n.choose(
                    'Отменить',
                    'Бас тарту',
                    'Cancel',
                );
            },
            get clear(): string {
                return i18n.choose(
                    'Очистить',
                    'Таза',
                    'Clear',
                );
            },
            get save(): string {
                return i18n.choose(
                    'Сохранить',
                    'Сақтау',
                    'Save',
                );
            },
        },
        fields: {
            get reasonKk(): string {
                return i18n.choose(
                    'Обоснование на казахском',
                    'Қазақ тіліндегі ақтау',
                    'Justification in Kazakh',
                );
            },
            get reasonRu(): string {
                return i18n.choose(
                    'Обоснование на русском',
                    'Орыс тіліндегі негіздеме',
                    'Justification in Russian',
                );
            },
        },
        get title(): string {
            return i18n.choose(
                'Обоснование',
                'Негіздеме',
                'Justification',
            );
        },
    },
};


@Component
export default class FzpRejectReasonCell extends ComponentBase {
    constructor() {
        super('');
    }


    // region Свойства
    /**
     * [Свойство компонента] Содержимое листа отчета
     */
    @Prop({ required: true })
    public readonly data!: Fzp.ReactiveReportPart;

    /**
     * Ключ строки
     */
    @Prop({ required: true })
    public readonly rowKey!: string;

    /**
     * Код функциональной группы
     */
    @Prop({ required: true })
    public readonly functionalGroupCode!: number | null;

    /**
     * Код функциональной подгруппы
     */
    @Prop({ required: false, default: null })
    public readonly functionalSubgroupCode!: number | null;

    /**
     * Код АБП
     */
    @Prop({ required: false, default: null })
    public readonly abpCode!: number | null;
    // endregion


    // region Утилиты
    public translates = translates;
    // endregion


    // region Отображаемые данные
    public get rejectReason(): Fzp.ReportRejectReason | null {
        return this.data.getRejectReason(this.rowKey);
    }

    public get rejectReasonText(): string | null {
        if (this.rejectReason === null) {
            return null;
        } else if (i18n.locale === 'kk') {
            return this.rejectReason.kk ?? this.rejectReason.ru ?? null;
        } else {
            return this.rejectReason.ru ?? this.rejectReason.kk ?? null;
        }
    }
    // endregion


    // region Модальное окно
    public isModalVisible = false;
    public modalReasonTextKk = '';
    public modalReasonTextRu = '';

    public get modalSaveButtonVariant(): string {
        if (this.rejectReason === null) {
            return 'primary';
        } else {
            return 'success';
        }
    }

    public get modalSaveButtonText(): string {
        if (this.rejectReason === null) {
            return this.translates.modal.actions.add;
        } else {
            return this.translates.modal.actions.save;
        }
    }

    public showModal() {
        this.modalReasonTextKk = this.rejectReason?.kk ?? '';
        this.modalReasonTextRu = this.rejectReason?.ru ?? '';
        this.isModalVisible = true;
    }

    public applyModalData() {
        this.isModalVisible = false;
        this.data.setRejectReason(
            this.functionalGroupCode,
            this.functionalSubgroupCode,
            this.abpCode,
            this.modalReasonTextKk,
            this.modalReasonTextRu,
        );
    }

    public clearModalData() {
        this.modalReasonTextKk = '';
        this.modalReasonTextRu = '';
    }

    public closeModal() {
        this.isModalVisible = false;
    }
    // endregion
}
